import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ISort } from '../../../interfaces';

@Component({
    selector: 'app-sort-cmp',
    templateUrl: 'sort.component.html'
})
export class SortComponent implements OnInit {
    //#region input
    @Input() options: ISort[];
    //#endregion

    //#region output
    @Output() onOptionChanged: EventEmitter<ISort> = new EventEmitter();
    @Output() onReverseChanged: EventEmitter<boolean> = new EventEmitter();
    //#endregion

    //#region properties
    selectedOption: ISort;
    reverse = false;
    //#endregion

    //#region lifecycle methods
    ngOnInit() {
        this.selectedOption = this.options[0];
    }
    //#endregion

    //#region methods
    setOption(option: ISort): void {
        this.selectedOption = option;
        this.onOptionChanged.emit(option);
    }

    toggleReverse(): void {
        this.reverse = !this.reverse;
        this.onReverseChanged.emit(this.reverse);
    }
    //#endregion
}
